import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {_extends, _inherits, _classCallCheck, _objectWithoutProperties, _possibleConstructorReturn} from './util';

let propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

let defaultProps = {
    tag: 'div'
};

let AppSidebarHeader = function (_Component) {
    _inherits(AppSidebarHeader, _Component);

    function AppSidebarHeader() {
        _classCallCheck(this, AppSidebarHeader);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    AppSidebarHeader.prototype.render = function render() {
        let _props = this.props,
            className = _props.className,
            children = _props.children,
            Tag = _props.tag,
            attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

        let classes = classNames(className, 'sidebar-header');
        return children ? React.createElement(
            Tag,
            _extends({className: classes}, attributes),
            children
        ) : null;
    };

    return AppSidebarHeader;
}(Component);

AppSidebarHeader.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
AppSidebarHeader.defaultProps = defaultProps;

export default AppSidebarHeader;
